import { detect } from 'detect-browser'
import {
  SET_DEVICE,
  // TODO: import action types added later
} from './actions/types'

const INITIAL_STATE = {
  browser: detect(),
  device: null,
}

function setDevice(state, action) {
  return {
    ...state,
    device: action.payload.device,
  }
}
// TODO: reflect state mutator functions for action types added later

function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_DEVICE:
      return setDevice(state, action)
    // TODO: add more action types if necessary
    default:
      break
  }

  return state
}

export default reducer
